import { Pipe, PipeTransform } from '@angular/core';
import { CardTypeCallToActions, Learning_Type, RouteTypes } from '@app/enums/_index';
@Pipe({
  name: 'routeTypesByCallToActions',
  pure: false,
  standalone: false,
})
export class RouteTypesByCallToActionsPipe implements PipeTransform {
  /**
   * Return transformed call to action string to return route type
   * NOTE: Pipe must be impure due to the aynchronous nature of the user service which contains the user subscription and enrollments.
   * @param callToAction - Call to action to transform to a given route type
   * @param instructionType - Learning type needed to determined route type state
   * @param isInternal - Force route type to be internal in case the instruction type is eLearning from the search catalog page
   * @returns - transformed call to action string
   */
  public transform(callToAction: string, instructionType: string, isInternal: boolean): string {
    switch (callToAction) {
      case CardTypeCallToActions.LEARN_MORE:
      case CardTypeCallToActions.SUBSCRIPTION_REQUIRED:
        // NOTE: Redirects back to subscription detail page
        return RouteTypes.SUBSCRIPTION;
      case CardTypeCallToActions.REQUEST_A_QUOTE:
        return RouteTypes.MAILTO;
      case CardTypeCallToActions.REQUEST_A_VOUCHER:
        return RouteTypes.MODAL;
      case CardTypeCallToActions.SIGN_IN:
        return RouteTypes.LOGIN;
      case CardTypeCallToActions.ENROLL:
        // NOTE: Used in the search component only where you can enroll automatically on the Enroll button
        // but user gets redirected to internal course detail with updated call to action state.
        // Make sure to keep this in sync with the search component load loadEnrollELearning
        if (
          isInternal &&
          (instructionType === Learning_Type.E_LEARNING ||
            instructionType === Learning_Type.SELF_STUDY ||
            instructionType === Learning_Type.QUICK_LEARNING ||
            instructionType === Learning_Type.CERTIFICATION_EXAM)
        ) {
          return RouteTypes.INTERNAL;
        } else {
          return RouteTypes.EXTERNAL;
        }
      case CardTypeCallToActions.SOLD_OUT:
        return RouteTypes.INTERNAL;
      case CardTypeCallToActions.VIEW_ENROLLMENT_MULTIPLE_OPTIONS:
      case CardTypeCallToActions.VIEW_ENROLLMENT_OPTIONS:
        return RouteTypes.INTERNAL;
      default:
        // Anything that is from Docebo like Start, Continue, etc...
        return RouteTypes.EXTERNAL;
    }
  }
}
